<div class="dialog--title"
  cdkDrag cdkDragHandle
  cdkDragRootElement=".cdk-overlay-pane"
  [cdkDragFreeDragPosition]="position"
  (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{data.sysText.editEmployerNotification_title | titlecase}}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <div class="notif-name">
    <mat-icon class="field-icon">alarm</mat-icon>
    <p class="grey1">{{ data.notification.name }}</p>
    <!-- buttons so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
    <button
      type="button"
      class="button-reset info-button"
      [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
      [matTooltip]="data.notification.description"
      [matTooltipShowDelay]="500"
      matTooltipPosition="above">
      <mat-icon class="button-icon">info_outline</mat-icon>
    </button>
  </div>
  <form [formGroup]="form">
    <div class="toggle-container">
      <app-slide-toggle
        [control]="enabled"
        [label]="(data.notification.alwaysEnabled ? data.sysText.alwaysOn : data.sysText.on)"
        [capitalizeLabel]="false"
        [isDisabled]="data.notification.alwaysEnabled">
      </app-slide-toggle>
    </div>
    <app-autocomplete-field
      [icon]="'email'"
      [label]="data.sysText.emailTemplate"
      [control]="emailTemplate"
      [options]="data.dialogData.emailTemplateOptions"
      [showSearchIcon]="true"
      [hint]="data.sysText.notificationEmailType.replace('@[emailType]', data.notification.emailType)"
      [usingDefaults]="usingDefaults"
      [defaultId]="data.notification.defaultEmailTemplateId"
      [sysTextForDefaults]="data.sysText">
    </app-autocomplete-field>
    <app-add-notif-recipients
      [formGroup]="form.controls.to"
      [dialogData]="data.dialogData"
      [sysText]="data.sysText"
      [header]="data.sysText.recipients"
      [recipientBoxLabel]="data.sysText.employerNotifications_to"
      [expanded]="true"
      [usingDefaults]="usingDefaults"
      [defaultRecipientTypeId]="data.notification.defaultRecipientTypeId"
      [defaultAdditionalRecipientTypeId]="data.notification.defaultAdditionalRecipientTypeId">
    </app-add-notif-recipients>
    <app-add-notif-recipients
      [formGroup]="form.controls.cc"
      [dialogData]="data.dialogData"
      [sysText]="data.sysText"
      [header]="data.sysText.employerNotifications_addCc"
      [recipientBoxLabel]="data.sysText.employerNotifications_cc"
      [expanded]="false">
    </app-add-notif-recipients>
    <app-add-notif-recipients
      [formGroup]="form.controls.bcc"
      [dialogData]="data.dialogData"
      [sysText]="data.sysText"
      [header]="data.sysText.employerNotifications_addBcc"
      [recipientBoxLabel]="data.sysText.employerNotifications_bcc"
      [expanded]="false">
    </app-add-notif-recipients>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="space-between">
  @let isSubmitting = isSubmitting$ | async;
  <div class="buttons-left">
    @if (data.notification.alwaysEnabled) {
      <!-- pressing restore uses the defaults, which disables it while it has focus, so it stays focusable (disabledInteractive)
      and the guard repeats the checks -->
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting || this.usingDefaults"
        disabledInteractive
        (click)="!isSubmitting && !this.usingDefaults && onRestoreDefaults()">
        <mat-icon class="button-icon restore-defaults-icon">settings_backup_restore</mat-icon>
        {{ data.sysText.restoreDefaults }}
      </button>
    }

    @if (!data.notification.alwaysEnabled && !(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting"
        (click)="onClear()">
        {{ data.sysText.clear }}
      </button>
    }
  </div>

  <div class="buttons-right">
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting"
        (click)="close(false)">
        {{ data.sysText.cancel }}
      </button>
    }
    @if (!data.notification.alwaysEnabled && (isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting"
        (click)="onClear()">
        {{ data.sysText.clear }}
      </button>
    }
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && onSubmit()">
      {{ data.sysText.save }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </div>
</mat-dialog-actions>
